import { createGlobalStyle } from 'styled-components'

// global style
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    border: 0;
    font-family: "Noto Sans KR";
    box-sizing: border-box;
  }
  body,
  th,
  td,
  input,
  select,
  textarea,
  div {
    font-size: 12px;
  }

  img {
    border: 0 none;
    max-width: 100%;
    height: auto;
  }

  button {
    font-size: 12px;
    line-height: 1.4;
    font-family: "Noto Sans KR";
    color: #181818;
  }
  
`

export default GlobalStyle
